import React from "react";
import { createStyles, Space, Text } from "@mantine/core";
import SurveySummaryResponsesStack from "../elements/SurveySummaryResponsesStack";
import Survey from "../services/model/Survey";

const useStyles = createStyles(() => ({
  heading: {
    fontSize: "16px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.16px;",
    textAlign: "left",
    color: "495057",
  },
}));

type SurveySummaryPanelProps = {
  survey: Survey;
};

const SurveySummaryPanel: React.FC<SurveySummaryPanelProps> = ({ survey }) => {
  const { classes } = useStyles();

  return (
    <div style={{ padding: "32px 40px", background: "#f7f7f8"}}>
      <Text className={classes.heading}>Responses</Text>
      <Space h="xl" />
      <SurveySummaryResponsesStack items={survey.questions} />
    </div>
  );
};

export default SurveySummaryPanel;
